export const prefix = "/api";
export const prefixV2 = "/api/v2";
